import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BulkDeductionEdit, BulkDeductionAddEdit, TabPanelAddEdit } from './Pages';

export const BulkDeductionRoutes = ({ match }) => (
    <Fragment>
    <Route exact path={`${match.path}`} component={TabPanelAddEdit} />
    </Fragment>
)